import { render, staticRenderFns } from "./Arribo.vue?vue&type=template&id=6773324a&scoped=true"
import script from "./Arribo.vue?vue&type=script&lang=js"
export * from "./Arribo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6773324a",
  null
  
)

export default component.exports